<body data-new-gr-c-s-check-loaded="14.1215.0" data-gr-ext-installed>
  <div class="master-video-editor">
    <nav>
      <div class="navbar">
        <div class="back-btn" (click)="goBack()">
          <i class="fa-solid fa-angle-left"></i>
          <span>Back</span>
        </div>
        <div class="undo-redo">
          <div class="undo" (click)="undo()">
            <span class="material-symbols-outlined">undo</span>
            <span class="span">Undo</span>
          </div>
          <div class="redo" (click)="redo()">
            <span class="material-symbols-outlined">redo</span>
            <span class="span">Redo</span>
          </div>
        </div>
        <!-- <div class="video-title">
          <label for="video-title">
            <input type="text" id="video-title" value="Untitled Video" />
            <i class="fa-solid fa-pen-to-square"></i>
          </label>
        </div> -->
        <div class="action-buttons">
          <button class="save" (click)="openCaricatureModal()">Change Photo</button>
          <button class="download" (click)="openCaricatureModal()">
            Download
          </button>
        </div>
      </div>
    </nav>

    <main class="c-main">
      <div class="vertical-container">
        <p class="mb-2">All Clips</p>
        <div class="vertical-clips-container swiper">
          <div
            class="vertical-clips swiper-wrapper"
            id="vertical-clips"
            #verticalContainer></div>
        </div>
        <button class="customize-button" (click)="openCustomizeClipsModal()">
          Customize Clips
        </button>
      </div>
      <div class="editing-workspace">
        <div class="editing-container">
          <div class="horizontal-clips-container swiper" #swiperHorizontal>
            <div
              class="horizontal-clips swiper-wrapper"
              id="horizontal-clips"
              #workspaceContainer></div>
            <!-- Add Arrows -->
            <div class="swiper-prev">
              <i class="fa-solid fa-chevron-down"></i>
            </div>
            <div class="swiper-next">
              <i class="fa-solid fa-chevron-up"></i>
            </div>
          </div>
          <!-- add pagination -->
          <div class="central-guided-line" #centralGuidedLine></div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="text-properties-container">
          <div class="bottom-container">
            <div class="more-edit-options">
              <div class="more-option" (click)="openAddEleContainer()">
                <i class="fa-regular fa-pen-to-square"></i>
                <p>More Edit Option</p>
              </div>
              <div class="more-modal" #mobileAddEleContainer>
                <button (click)="addEle('text')">
                  <span class="material-symbols-outlined">title</span>
                  <p>Add Text</p>
                </button>
                <button (click)="imageInput.click()">
                  <span
                    class="material-symbols-outlined">add_photo_alternate</span>
                  <p>Add Image</p>
                </button>
              </div>
            </div>
            <div class="customize-clip" (click)="openCustomizeClipsModal()">
              <i class="fa-solid fa-layer-group"></i>
              <p>Customize Clips</p>
            </div>
          </div>
          <div
            class="text-display-container"
            #defaultTextPropertiesContainer></div>
          <div class="text-editing-container" #textEditContainer>
            <p class="back-btn" (click)="closeTextEditContainer($event)">
              <i class="fa-solid fa-angle-left"></i>
              <span>Back</span>
            </p>
            <div class="text-display-area">
              <div class="language">
                <p>Language</p>
                <select
                  name="selectLanguage"
                  id="selectLanguage"
                  [(ngModel)]="selectedLanguage"
                  (change)="addFontStyling(selectedLanguage)">
                  <option value="english">English</option>
                  <option value="hindi">Hindi</option>
                  <option value="tamil">Tamil</option>
                  <option value="marathi">Marathi</option>
                  <option value="telugu">Telugu</option>
                  <option value="gujarati">Gujarati</option>
                  <option value="arabic">Arabic</option>
                  <option value="kannada">Kannada</option>
                </select>
              </div>
              <div class="text-area">
                <textarea
                  name="textarea"
                  id="text-area-0"
                  cols="30"
                  rows="8"></textarea>
              </div>
            </div>
            <div class="text-styling-container">
              <div class="font-container">
                <div
                  class="font-family-container"
                  (click)="openDropDown($event, 1)">
                  <p>
                    <span class="data-family">Arial</span>
                    <i class="fa-solid fa-angle-down"></i>
                  </p>
                  <div class="font-family-dropdown" #fontFamilyDropdown></div>
                </div>
                <div
                  class="font-style-container"
                  (click)="openDropDown($event, 5)">
                  <p>
                    <span class="data-weight">Regular</span>
                    <i class="fa-solid fa-angle-down"></i>
                  </p>
                  <div class="font-style-dropdown" #fontWeightDropdown>
                    <p data-weight="normal">Regular</p>
                    <p data-weight="italic">Italic</p>
                    <p data-weight="bold">Bold</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-more-styling-container">
              <div
                class="font-size-container"
                (click)="openDropDown($event, 6)">
                <p>
                  <span class="data-size value">20</span>
                  <span class="label">Font Size</span>
                </p>
                <div class="font-size-dropdown" #fontSizeDropdown></div>
              </div>
              <div
                class="font-color-container"
                (click)="openDropDown($event, 4)">
                <p>
                  <span class="data-color"></span>
                  <span class="label">Color</span>
                </p>
                <div class="font-color-dropdown" #fontColorDropdown>
                  <label class="color-picker" for="color-picker">
                    <input
                      type="color"
                      name="color-picker"
                      (input)="displaySelectedColor($event)"
                      (change)="handleFontColor($event, 'input')" />
                    <i class="fa-solid fa-eye-dropper"></i>
                  </label>
                  <div class="color-shades"></div>
                </div>
              </div>
              <div
                class="font-alignment-container"
                (click)="openDropDown($event, 2)">
                <p>
                  <i class="fa-solid fa-align-justify"></i>
                  <span class="label">Alignment</span>
                </p>
                <div class="font-alignment-dropdown" #textAlignDropdown>
                  <div data-align="left" class="left-align">
                    <p>
                      <i class="fa-solid fa-align-left"></i>
                      <span class="label">Left</span>
                    </p>
                  </div>
                  <div data-align="center" class="center-align">
                    <p>
                      <i class="fa-solid fa-align-center"></i>
                      <span class="label">Center</span>
                    </p>
                  </div>
                  <div data-align="right" class="right-align">
                    <p>
                      <i class="fa-solid fa-align-right"></i>
                      <span class="label">Right</span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="font-lineheight-container"
                (click)="openDropDown($event, null)">
                <p>
                  <i class="fa-solid fa-text-height"></i>
                  <span class="label">Line Height</span>
                </p>
                <div class="font-lineheight-dropdown" #textLineHeightDropdown>
                  <p>
                    <span class="label">Line Height</span>
                    <span class="value">1.2</span>
                  </p>
                  <input
                    type="range"
                    min="0.5"
                    max="3"
                    step="0.1"
                    (input)="handleLineHeight($event)" />
                </div>
              </div>
            </div>
            <!-- <div class="text-extra-properties-container">
              <div
                class="text-animation-container"
                (click)="openDropDown($event, 3)"
              >
                <p>
                  <span class="data-animation">Select Animation</span>
                  <i class="fa-solid fa-angle-down"></i>
                </p>
                <div class="text-animation-dropdown">
                  <p class="active" data-animation="null">
                    <span>No Animation</span>
                  </p>
                  <p data-animation="Animation 1">
                    <span>Animation 1</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 2">
                    <span>Animation 2</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 3">
                    <span>Animation 3</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 4">
                    <span>Animation 4</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 5">
                    <span>Animation 5</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 6">
                    <span>Animation 6</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 7">
                    <span>Animation 7</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 8">
                    <span>Animation 8</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 9">
                    <span>Animation 9</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                  <p data-animation="Animation 10">
                    <span>Animation 10</span>
                    <i class="fa-regular fa-eye"></i>
                  </p>
                </div>
              </div>
            </div> -->
          </div>
          <div class="add-options-container" #addEleContainer>
            <p class="back-btn" (click)="closeTextEditContainer($event)">
              <i class="fa-solid fa-angle-left" aria-hidden="true"></i>
              <span>Back</span>
            </p>
            <div class="add-btns">
              <button (click)="addEle('text')">
                <span class="material-symbols-outlined">title</span>
                <p>Add Text</p>
              </button>
              <button (click)="addEle('image')">
                <span
                  class="material-symbols-outlined">add_photo_alternate</span>
                <p>Add Image</p>
              </button>
            </div>
          </div>
          <div class="images-container" #imageOptionContainer>
            <p class="back-btn" (click)="closeTextEditContainer($event)">
              <i class="fa-solid fa-angle-left"></i>
              <span>Back</span>
            </p>
            <div class="add-image">
              <p>Add Custom Image</p>
              <input
                type="file"
                name="image"
                id="image-input"
                #imageInput
                hidden
                min="1"
                max="1"
                accept="image/*" />
              <button class="choose-image" (click)="imageInput.click()">
                <i class="fa-solid fa-plus"></i>
                <p>Choose Image</p>
              </button>
            </div>
            <div class="display-custom-images" #displayUploadedImage>
              <p>Uploaded Images</p>
              <div class="all-images" #uploadedImageContainer></div>
            </div>
          </div>
        </div>
        <div class="bottom-properties-container">
          <div class="properties">
            <button (click)="openTextEditMobileModal()">
              <p style="white-space: nowrap;">Edit Text</p>
               
            </button>
            <div
              class="mobile-fontfamily"
              (click)="openMobileDropdown('mobile-fontfamily-value', $event)">
              <svg
                fill="none"
                height="15"
                viewBox="0 0 15 15"
                width="15"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z"
                  fill="currentColor" />
              </svg>
              <p>Font</p>
            </div>
            <div
              class="mobile-fontsize"
              (click)="openMobileDropdown('mobile-fontsize-value', $event)">
              <svg
                fill="none"
                height="15"
                viewBox="0 0 15 15"
                width="15"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  clip-rule="evenodd"
                  d="M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z"
                  fill="currentColor"
                  fill-rule="evenodd" />
              </svg>
              <p>Font Size</p>
            </div>
            <div
              class="mobile-fontweight"
              (click)="openMobileDropdown('mobile-fontweight-value', $event)">
              <svg
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.96951 16.1675L14.5596 3.65608C14.8657 2.82169 16.006 2.78376 16.388 3.5423L16.4372 3.65608L21.9388 18.6528C22.129 19.1713 21.8628 19.7458 21.3443 19.936C20.8629 20.1126 20.3331 19.8958 20.1076 19.4488L20.0611 19.3416L18.6505 15.4985H12.3455L10.9039 19.4183L10.8629 19.4972L10.7908 19.6054L10.7133 19.6952L10.6284 19.7729L10.5459 19.8332L10.4955 19.864L10.4114 19.9072L10.3074 19.9478L10.2027 19.9759L10.0695 19.9948L9.96214 19.9969L9.89154 19.9919L9.78899 19.9755L9.63901 19.931L9.56968 19.9014L9.46966 19.847L9.35809 19.7669L9.26643 19.6805L9.20247 19.6048L9.14122 19.5149L9.08713 19.4124L8.34151 17.4995H4.65451L3.93178 19.3597C3.74591 19.8376 3.23292 20.0916 2.74846 19.9652L2.63733 19.9292C2.15937 19.7433 1.90536 19.2303 2.03178 18.7459L2.06778 18.6348L5.56631 9.63856C5.88116 8.82897 6.98716 8.79042 7.37735 9.52291L7.43032 9.63856L9.96951 16.1675L14.5596 3.65608L9.96951 16.1675ZM6.49832 12.76L5.43251 15.4995H7.56351L6.49832 12.76ZM15.4984 6.90404L13.0785 13.4985H17.9165L15.4984 6.90404Z"
                  fill="#212121" />
              </svg>
              <p>Font Weight</p>
            </div>
            <div
              class="mobile-color"
              (click)="openMobileDropdown('mobile-fontcolor-value', $event)">
              <p class="mobile-selected-color"></p>
              <p>Color</p>
            </div>
            <div class="mobile-delete" (click)="deleteText($event)">
              <i class="fa-solid fa-trash"></i>
              <p>Delete</p>
            </div>
            <div
              class="mobile-align"
              (click)="openMobileDropdown('mobile-fontalign-value', $event)">
              <i class="fa-solid fa-align-justify" aria-hidden="true"></i>
              <p>Align</p>
            </div>
            <div
              class="mobile-lineheight"
              (click)="
                openMobileDropdown('mobile-fontlineheight-value', $event)
              ">
              <i class="fa-solid fa-text-height" aria-hidden="true"></i>
              <p>Line Height</p>
            </div>
            <div
              class="mobile-animation"
              (click)="openMobileDropdown('mobile-textanimation-value', $event)">
              <i class="fa-solid fa-video" aria-hidden="true"></i>
              <p>Start Animation</p>
            </div>
          </div>
          <div class="title-container">
            <p (click)="openTextEditMobileModal()">Edit Text</p>
            <p (click)="openMobileDropdown('mobile-fontfamily-value', $event)">
              Font
            </p>
            <p (click)="openMobileDropdown('mobile-fontsize-value', $event)">
              Font Size
            </p>
            <p (click)="openMobileDropdown('mobile-fontweight-value', $event)">
              Font Weight
            </p>
            <p (click)="openMobileDropdown('mobile-fontcolor-value', $event)">
              Font Color
            </p>
            <p (click)="deleteText($event)">Delete</p>
            <p (click)="openMobileDropdown('mobile-fontalign-value', $event)">
              Align
            </p>
            <p
              (click)="
                openMobileDropdown('mobile-fontlineheight-value', $event)
              ">
              Line Height
            </p>
            <p
              (click)="openMobileDropdown('mobile-textanimation-value', $event)">
              Start Animation
            </p>
          </div>
          <div class="modal1 mobile-fontfamily-value">
            <div class="language">
              <p>Language</p>
              <select
                name="selectLanguage"
                id="selectLanguage"
                onchange="addFontStyling(this.value)">
                <option value="english">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Tamil">Tamil</option>
                <option value="Marathi">Marathi</option>
                <option value="Telugu">Telugu</option>
                <option value="Gujarati">Gujarati</option>
                <option value="Arabic">Arabic</option>
                <option value="Kannada">Kannada</option>
              </select>
            </div>
            <div
              class="mobile-fontfamily-display-container"
              (click)="handleFontFamily($event)">
              <p class="hidden"><span class="data-family"></span></p>
              <div class="mobile-fontfamily-display" #mobileFontFamily></div>
            </div>
          </div>
          <div class="modal1 mobile-fontsize-value">
            <div class="action">
              <i
                class="fa-solid fa-minus"
                (click)="handleClickMobileFontsize($event, -2)"></i>
              <input
                type="range"
                name="font-size"
                id="mobile-font-slide"
                min="5"
                max="50"
                value="20"
                (input)="handleMobileFontSize($event)" />
              <i
                class="fa-solid fa-plus"
                (click)="handleClickMobileFontsize($event, 2)"></i>
            </div>
            <p class="font-slider-value">20</p>
          </div>
          <div class="modal1 mobile-fontweight-value">
            <p class="hidden">
              <span class="data-weight">Regular</span>
              <i class="fa-solid fa-angle-down"></i>
            </p>
            <div class="mobile-fontweight-dropdown" #mobileFontWeight></div>
          </div>
          <div class="modal1 mobile-fontcolor-value">
            <label class="color-picker" for="color-picker">
              <p (click)="triggerParentInputClick($event)">
                <span class="data-color"></span>
                <span class="label">Color</span>
              </p>
              <input
                type="color"
                name="color-picker"
                (input)="displaySelectedColor($event)"
                (change)="handleFontColor($event, 'input')" />
            </label>
            <div
              class="mobile-color-shades"
              #mobileFontColor
              (click)="handleFontColor($event)"></div>
          </div>
          <div
            class="modal1 mobile-fontalign-value"
            (click)="handleTextAlignment($event)">
            <div data-align="left" class="left-align">
              <p>
                <i class="fa-solid fa-align-left"></i>
                <span class="label">Left</span>
              </p>
            </div>
            <div data-align="center" class="center-align">
              <p>
                <i class="fa-solid fa-align-center"></i>
                <span class="label">Center</span>
              </p>
            </div>
            <div data-align="right" class="right-align">
              <p>
                <i class="fa-solid fa-align-right"></i>
                <span class="label">Right</span>
              </p>
            </div>
          </div>
          <div class="modal1 mobile-fontlineheight-value">
            <div class="action">
              <i
                class="fa-solid fa-minus"
                (click)="handleClickMobileLineheight(-0.2, $event)"></i>
              <input
                type="range"
                name="font-size"
                id="mobile-lineheight-slide"
                min="0.5"
                max="3"
                step="0.1"
                (input)="handleMobileLineheight($event)" />
              <i
                class="fa-solid fa-plus"
                (click)="handleClickMobileLineheight(0.2, $event)"></i>
            </div>
            <p class="font-slider-value">20</p>
          </div>
          <!-- <div class="modal mobile-textanimation-value">
            <div
              class="mobile-textanimation-container"
              (click)="handleAnimation($event)"
            >
              <p class="hidden"><span class="data-animation"></span></p>
              <div class="mobile-textanimation-display">
                <p class="active" data-animation="null">
                  <span>No Animation</span>
                </p>
                <p data-animation="Animation 1">
                  <span>Animation 1</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 2">
                  <span>Animation 2</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 3">
                  <span>Animation 3</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 4">
                  <span>Animation 4</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 5">
                  <span>Animation 5</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 6">
                  <span>Animation 6</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 7">
                  <span>Animation 7</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 8">
                  <span>Animation 8</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 9">
                  <span>Animation 9</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
                <p data-animation="Animation 10">
                  <span>Animation 10</span>
                  <i class="fa-regular fa-eye"></i>
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </main>

    <!-- Edit Image Modal -->
    <div class="edit-image" id="edit-image" #editImageContainer>
      <div class="image-modal-container">
        <i
          class="fa-solid fa-xmark close-btn"
          (click)="closeModal($event, true)"></i>
        <div class="image-workspace" id="image-workspace">
          <div
            class="image-container mask-image-container"
            id="image-container"
            #editImageDisplayContainer></div>
        </div>
        <div class="crop-options">
          <button class="crop-option rotate" #rotateBtnX>
            <i class="fa-solid fa-rotate-left"></i>
            <span>Rotate Left</span>
          </button>
          <button class="crop-option rotate" #rotateBtnY>
            <i class="fa-solid fa-rotate-right"></i>
            <span>Rotate Right</span>
          </button>
          <button class="crop-option flip" #flipBtnX>
            <span class="material-symbols-outlined">flip</span>
            <span>Horizontal</span>
          </button>
          <button class="crop-option flip" #flipBtnY>
            <span class="material-symbols-outlined"
              style="rotate: 90deg">flip</span>
            <span>Vertical</span>
          </button>
        </div>
        <button
          class="accept crop"
          id="crop-and-save"
          #cropAndSave
          (click)="cropAndSaveAction()">
          Crop & Save
        </button>
      </div>
    </div>

    <!-- Rearrange Clips Modal -->
    <div class="rearrange-container">
      <div class="rearrange-clips">
        <p class="title">Customize your Clips</p>
        <i class="fa-solid fa-xmark close-btn" (click)="closeModal($event)"></i>
        <div class="slide-btns">
          <p class="rearrange active" (click)="switchContainer('0%')">
            Rearrange/Delete
          </p>
          <p class="add-clips" (click)="switchContainer('-53%')">Add</p>
        </div>
        <div class="rearrange-add-container">
          <div
            class="rearrange-clips-container"
            id="rearrange"
            #rearrangeClipsContainer></div>
          <div class="add-clips-container" id="add" #addClipsContainer></div>
        </div>
        <div class="action-buttons">
          <button
            class="cancel-customize"
            (click)="closeModalRearrange($event)">
            Cancel
          </button>
          <button class="save-customize" (click)="saveRearrangeClips()">
            Save
          </button>
        </div>
      </div>
    </div>
    <!-- Fixed and Caricature Images Modal -->
    <div class="caricature-modal" #caricatureModal>
      <div class="caricature-content">
        <i class="fa-solid fa-xmark close-btn" (click)="closeModal($event)"></i>
        <div class="row">
          <div class="col-md-6">
            <div class="music-container">
              <div class="title">
                <p>Choose your Music <span>(only mp3 file)</span></p>
              </div>
              <div class="duration-container">
                <p>Total Clip Duration: <span class="clip-duration"></span></p>
                <p>Total Music Duration: <span
                    class="music-duration"></span></p>
              </div>
              <div class="choose-music mt-3">
                <button (click)="chooseMusic()"
                  [disabled]="isShowPreviewStatus">
                  <i class="fa-solid fa-music"></i>
                  <p>Change Music</p>
                </button>
                <div class="music-player">
                  <p class="music-name"
                    id="custom-music-name">{{musicFileName}}</p>
                  <audio src hidden id="custom-music-src" #audioEle></audio>
                  <i
                    class="fa-regular fa-circle-play"
                    (click)="handleMusic($event)"></i>
                  <i
                    class="fa-regular fa-circle-pause"
                    (click)="handleMusic($event)"></i>
                </div>
                <input
                  type="file"
                  name="music"
                  id="custom-music-input"
                  hidden
                  accept="audio/*"
                  minlength="1"
                  maxlength="1" />
              </div>
            </div>
            <div class="title fixed-image-title">
              <p class="mt-4 mb-3">Fixed Images</p>
            </div>
            <div class="fixed-images-container"></div>
            <div class="couple-images">
              <div class="groom-image">
                <div class="title">
                  <p>Groom Image</p>
                </div>
                <div class="groom-image-container">
                  <img
                    src="/assets/groomImage.png"
                    alt
                    id="groomImage" />
                </div>
                <button class="upload-image"
                  (click)="changeCoupleImage('groom')">
                  <i class="fa-solid fa-arrow-up-from-bracket"></i>
                  <p>Upload Image</p>
                </button>
              </div>
              <div class="bride-image">
                <div class="title">
                  <p>Bride Image</p>
                </div>
                <div class="bride-image-container">
                  <img
                    src="/assets/brideImage.png"
                    alt
                    id="brideImage" />
                </div>
                <button class="upload-image"
                  (click)="changeCoupleImage('bride')">
                  <i class="fa-solid fa-arrow-up-from-bracket"></i>
                  <p>Upload Image</p>
                </button>
              </div>
            </div>
            <div class="error">
              <p>Add Couple Images</p>
            </div>
            <!-- <div class="choose-currency">
              <div>
                <input
                  type="radio"
                  name="currency"
                  data-sign="₹"
                  id="inr"
                  value="INR"
                  checked
                  (click)="changePriceAccordingToCurrency()" />
                <label for="inr">INR</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="currency"
                  data-sign="$"
                  id="usd"
                  value="USD"
                  (click)="changePriceAccordingToCurrency()" />
                <label for="usd">USD</label>
              </div>
            </div> -->
          </div>
          <div class="col-md-6">
            <div
              class="row justify-content-center justify-content-center align-items-center progress-mt"
              *ngIf="isShowPreviewStatus">
              <div class="col-md-auto col-auto">
                <div [class]="ProgressBarClass">
                  <span>{{ ProgressBarPercentage }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12 mmt-30 mt-3">
                <div
                  class="process-label"
                  style="clear: both"
                  *ngIf="jobProgressData?.TaskType">
                  <h3 class="video-progress-text"
                    *ngIf="ProgressBarPercentage != '100'"
                    [class]="ProgressTaskClass">
                    {{ jobProgressData?.TaskType }}
                  </h3>
                  <h3
                    *ngIf="ProgressBarPercentage == '100'"
                    class="mb-0 text-success">
                    {{ jobProgressData?.TaskType }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row  mt-4">
          <div class="col-md-6">
            <button class="create-video sample" (click)="GenerateVideo($event)">
              <p>Create FREE Sample Video<br /> (With Watermark)</p>
            </button>
          </div>
          <div class="col-md-6 mmt-15">
            <button class="create-video" (click)="payAndDownload()"
              [disabled]="isSaveDisable || isPayDisable">
              <p>Pay & Download High Quality Video<br /> (Without Watermark)</p>
            </button>
          </div>
          <div class="col-md-12 mt-3 mmt-15">
            <button class="create-video sample" (click)="createVideo(0)">
              <p>Save as Draft</p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="loader-modal">
      <div class="loader"></div>
    </div>
    <div class="mobile-edit-text-modal">
      <div class="modal-content">
        <p>Edit Text</p>
        <textarea name="edit-text" id="textarea" cols="30" rows="10"></textarea>
        <div class="action">
          <button class="cancel" (click)="closeModal($event, false, true)">
            <p>Cancel</p>
          </button>
          <button class="update" (click)="updateTextFromMobileEdit()">
            <p>Update Text</p>
          </button>
        </div>
      </div>
    </div>

    <!-- Animation Preview Modal -->
    <div class="animation-preview-modal">
      <div class="animation-preview">
        <i class="fa-solid fa-xmark close-btn" (click)="closeModal($event)"></i>
        <div class="animation-gif">
          <img src />
        </div>
      </div>
    </div>

    <!-- Music Crop Modal -->
    <div class="music-crop-modal" #musicCropModal>
      <div class="music-content">
        <i class="fa-solid fa-xmark close-btn" (click)="closeModal($event)"></i>
        <div class="title">
          <p>Crop Your Music:</p>
        </div>
        <div class="content">
          <div id="waveformContainer">
            <canvas id="waveformCanvas" #canvas></canvas>
            <div id="startHandle" class="crop-handle" draggable="false"></div>
            <div id="endHandle" class="crop-handle" draggable="false"></div>
            <div id="playbackIndicator"></div>
          </div>
          <div class="duration-container">
            <div class="start">
              <p>Start :</p>
              <input type="text" name id="start-duration" />
            </div>
            <div class="end">
              <p>End :</p>
              <input type="text" name id="end-duration" />
            </div>
            <div class="duration">
              <p>Duration :</p>
              <p id="total-duration"></p>
            </div>
            <div
              class="play-music"
              (click)="playCroppedAudio($event)"
              data-action="play">
              <p>Play</p>
              <i class="fa-solid fa-circle-play"></i>
            </div>
          </div>
          <div class="action-container">
            <button
              class="play-music"
              (click)="playCroppedAudio($event)"
              data-action="play">
              <p>Play</p>
              <i class="fa-solid fa-circle-play"></i>
            </button>
            <button class="crop-audio" (click)="cropAudio()">Crop Audio</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Modal -->
    <!-- <div class="payment-modal">
      <div class="payment-content">
        <p class="title">Payment Failed</p>
        <p class="price">
          <span class="amount">999</span><span class="currency"> INR</span>
        </p>
        <p class="error-message">
          The system experienced an unexpected internal error. If payment
          deducted from your account Contact Us. Or Try again.
        </p>
        <button class="try-payment" (click)="createVideo('purchase')">
          Try Pay Again
        </button>
        <button class="contact-us">Contact Us</button>
        <button class="cancel-payment" (click)="closePaymentErrorModal()">
          No thanks
        </button>
      </div>
    </div> -->

    <!-- Max Draft Count Modal -->
    <!-- <div class="draft-modal">
      <div class="draft-content">
        <i class="fa-solid fa-xmark close-btn" (click)="closeDraftModal()"></i>
        <div class="title">
          <p>You have reached max number of drafts <br />Try Delete some.</p>
        </div>
        <div class="content">
          <button class="delete-draft" (click)="goToDraft()">
            <p>Go To Draft Page</p>
          </button>
          <button class="purchase" (click)="createVideo('purchase')">
            <p>Create High Quality Video</p>
            <p>
              at <span class="price"></span> <span class="strike-price"></span>
            </p>
          </button>
        </div>
      </div>
    </div> -->

    <!-- Login Modal -->
    <!-- <div class="login-modal">
      <div class="login-content">
        <div class="left">
          <div class="img-container">
            <img src="/assets/images/logo.webp" alt="Logo" />
          </div>
        </div>
        <div class="right">
          <div class="close-btn" (click)="handleLoginModal('close')">
            <i class="fa-solid fa-xmark"></i>
          </div>
          <div class="signin-container active">
            <div class="title">
              <p>Sign In</p>
            </div>
            <div class="content">
              <p>Welcome to <span>Invito</span></p>
            </div>
            <form class="input-form">
              <div class="email-container">
                <i class="fa-solid fa-envelope"></i>
                <label for="email">
                  <input
                    type="email"
                    name="email"
                    id="register-email"
                    required />
                  <span>Email</span>
                </label>
              </div>
              <div class="password-container">
                <i class="fa-solid fa-lock"></i>
                <label for="password">
                  <input
                    type="password"
                    name="password"
                    id="register-pass"
                    required />
                  <span>Password</span>
                  <span class="show-pass" (click)="showHidePassword($event)"><i
                      class="fa-regular fa-eye"></i></span>
                </label>
              </div>
              <div
                class="forgot-pass"
                data-type="reset"
                (click)="goToPage($event)">
                <p>Forgot Password ?</p>
              </div>
              <button class="signin" (click)="signIn()">Sign in</button>
            </form>
            <div class="error">
              <p>Error</p>
            </div>
            <div class="create-account">
              <hr />
              <p>
                Not a member yet ?
                <span data-type="signup" (click)="goToPage($event)">Sign
                  Up</span>.
              </p>
            </div>
          </div>
          <div class="signup-container">
            <div class="title">
              <p>Sign Up</p>
            </div>
            <form class="input-form">
              <div>
                <i class="fa-solid fa-user"></i>
                <label for="fullname">
                  <input
                    type="text"
                    name="fullname"
                    id="create-fullname"
                    required />
                  <span>Full Name</span>
                </label>
              </div>
              <div>
                <i class="fa-solid fa-phone"></i>
                <label for="phonenumber">
                  <input
                    type="text"
                    name="phonenumber"
                    id="create-phonenumber"
                    required
                    pattern="[0-9]{10,15}"
                    maxlength="15"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                  <span>Phone</span>
                </label>
              </div>
              <div>
                <i class="fa-solid fa-envelope"></i>
                <label for="email">
                  <input type="email" name="email" id="create-email" required />
                  <span>Email</span>
                </label>
              </div>
              <div>
                <i class="fa-solid fa-lock"></i>
                <label for="password">
                  <input
                    type="password"
                    name="password"
                    id="create-pass"
                    required />
                  <span>Password</span>
                  <span class="show-pass" (click)="showHidePassword($event)"><i
                      class="fa-regular fa-eye"></i></span>
                </label>
              </div>
              <button class="signin" (click)="signUp()">Sign up</button>
            </form>
            <div class="error">
              <p></p>
            </div>
            <div class="create-account">
              <hr />
              <p>
                Already have an account ?
                <span data-type="signin" (click)="goToPage($event)">Sign
                  In</span>.
              </p>
            </div>
          </div>
          <div class="reset-container">
            <div class="title">
              <p>Forgot Your Password ?</p>
            </div>
            <div class="input-form">
              <form class="email-container">
                <i class="fa-solid fa-user"></i>
                <label for="email">
                  <input type="email" name="email" id="forgot-email" />
                  <span>Email</span>
                </label>
                <button class="signin reset-btn">
                  Send reset Password link
                </button>
              </form>
              <div class="error">
                <p></p>
              </div>
              <button
                class="signin"
                data-type="signin"
                (click)="goToPage($event)">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <input
      id="couple-image-input"
      type="file"
      accept="image/*"
      min="1"
      max="1"
      hidden />
    <button class="more-editing-option" (click)="openAddEleContainer()">
      More Edit Option
    </button>
  </div>
</body>
